import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import es from './locales/es';
import pt from './locales/pt';
import { localUser } from '@/services/session-service';

const user = localUser();

const language = user?.language || 'es';

i18n
    // .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
            pt: { translation: pt }
        },
        lng: language,
        fallbackLng: 'es',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n; 